import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class CheckinService {
	constructor(private http: HttpClient) {}

	public getCheckins(): Observable<any> {
		const url =
			environment.backend.checkinURL + `/checkin/aggregation/last-month`;

		const headers = new HttpHeaders({
			Authorization: `${localStorage.getItem('idToken')}`,
			'access-token': `${localStorage.getItem('accessToken')}`,
			'nina-secret': '0rangotang0Azul',
		});

		return this.http.get(url, { headers });
	}
}
